<script lang="ts">
	import ChevronRight from '$lib/assets/images/icons/chevron-right.svg?component';
	import { page } from '$app/stores';
	import __ from '$lib/stores/TranslationStore';
	import Cta from '$lib/components/Global/Cta.svelte';
	import Partnerships from './Partnerships.svelte';
	import { createEventDispatcher } from 'svelte';
	import { fly } from 'svelte/transition';
	import { twMerge } from 'tailwind-merge';

	let showMoreNote: boolean = false;
	export let clientName: string;
	export let directContactRequested = false;
	let className: string = '';
	export { className as class };
	export let custom: boolean = false;

	const dispatch = createEventDispatcher();
</script>

<div
	in:fly
	class={twMerge('container mx-auto flex flex-col gap-4 px-0 text-dark lg:py-4', className)}
>
	<div class="flex flex-col gap-[30px]">
		{#if custom}
			<slot name="custom" />
		{:else}
			<header class="flex flex-col gap-[10px]">
				<h1 class="py-2 text-2xl">
					<strong>{clientName}</strong>, {$__('estas são as melhores soluções para si')}
				</h1>
				<p>
					{$__(
						'Procuramos o crédito mais vantajoso para si do mercado, feito à medida dos seus sonhos.'
					)}
				</p>
			</header>
			<main>
				<slot />
			</main>
		{/if}
		<footer class="flex flex-col gap-[30px]">
			{#if !custom}
				<div>
					<p class="text-xs md:line-clamp-none" class:line-clamp-2={!showMoreNote}>
						<span class="mr-1"><strong>{$__('Nota importante')}:</strong></span>
						<slot name="note">
							{$__(
								'Os valores apresentados nesta simulação são valores de referência de acordo com os dados colocados. As condições podem variar consoante o banco. Entre em contacto para ter mais informações e avançar com o processo online gratuito.'
							)}
						</slot>
					</p>
					<button
						on:click={() => (showMoreNote = !showMoreNote)}
						class="mt-2 flex items-center gap-2 text-xs text-primary md:hidden"
					>
						{$__('Ver mais')}
						<ChevronRight
							class="h-2 stroke-primary stroke-[10px] transition-transform {showMoreNote
								? '-rotate-90'
								: 'rotate-90'}"
						/>
					</button>
				</div>
			{/if}
			<div class="w-ful flex flex-col items-center md:mx-auto md:flex-row md:gap-10">
				<slot name="actions">
					<button
						on:click={() => dispatch('retry')}
						class="order-last my-5 w-full text-center font-semibold text-primary md:w-auto md:px-24 lg:order-first"
					>
						<u class="whitespace-nowrap border-b-2 border-primary no-underline">
							{$__('Refazer simulação')}
						</u>
					</button>
					<Cta
						on:click={() => dispatch('contact')}
						class="w-full {directContactRequested ? 'cursor-not-allowed bg-inactive' : ''}"
						type="button"
						props={{ disabled: directContactRequested }}
					>
						<span class="lg:hidden">
							{$__('Falar connosco')}
						</span>
						<span class="hidden lg:inline-block">
							{$__('Solicitar contacto direto')}
						</span>
					</Cta>
				</slot>
			</div>
		</footer>
	</div>

	<slot name="bottom">
		<Partnerships />
	</slot>
</div>
